import { CHANNEL_CONNECTION_WORKPLACECHAT_DOCUMENTATION_CLICKED, CHANNEL_CONNECTION_WORKPLACECHAT_INSTALL_CLICKED, CHANNEL_CONNECTION_WORKPLACECHAT_INSTALL_CONFIRMED, CHANNEL_CONNECTION_WORKPLACECHAT_UNINSTALL_CLICKED, CHANNEL_CONNECTION_WORKPLACECHAT_UNINSTALL_CONFIRMED, CHANNEL_CONNECTION_WORKPLACECHAT_UNINSTALL_CANCELED, } from './WorkplaceSegmentEvents';
export class WorkplaceSegmentService {
    static $inject = ['SegmentService'];
    constructor(SegmentService) {
        this.SegmentService = SegmentService;
    }
    setApplication(application) {
        this.application = application;
    }
    trackConnectionWorkplaceChatDocumentationClicked(payload) {
        this.trackEvent(CHANNEL_CONNECTION_WORKPLACECHAT_DOCUMENTATION_CLICKED, payload);
    }
    trackConnectionWorkplaceChatInstallClicked(payload) {
        this.trackEvent(CHANNEL_CONNECTION_WORKPLACECHAT_INSTALL_CLICKED, payload);
    }
    trackConnectionWorkplaceChatInstallConfirmed(payload) {
        this.trackEvent(CHANNEL_CONNECTION_WORKPLACECHAT_INSTALL_CONFIRMED, payload);
    }
    trackConnectionWorkplaceChatUninstallClicked(payload) {
        this.trackEvent(CHANNEL_CONNECTION_WORKPLACECHAT_UNINSTALL_CLICKED, payload);
    }
    trackConnectionWorkplaceChatUninstallConfirmed(payload) {
        this.trackEvent(CHANNEL_CONNECTION_WORKPLACECHAT_UNINSTALL_CONFIRMED, payload);
    }
    trackConnectionWorkplaceChatUninstallCanceled(payload) {
        this.trackEvent(CHANNEL_CONNECTION_WORKPLACECHAT_UNINSTALL_CANCELED, payload);
    }
    trackEvent(event, payload) {
        this.SegmentService.createBotTrack(event, this.application, payload);
    }
}
WorkplaceSegmentService.$inject = ['SegmentService'];
